export var CasePhoneContactInformationType;
(function (CasePhoneContactInformationType) {
    CasePhoneContactInformationType[CasePhoneContactInformationType["UNKNOWN"] = 1] = "UNKNOWN";
    CasePhoneContactInformationType[CasePhoneContactInformationType["PHONE"] = 2] = "PHONE";
    CasePhoneContactInformationType[CasePhoneContactInformationType["MOBILE"] = 3] = "MOBILE";
})(CasePhoneContactInformationType || (CasePhoneContactInformationType = {}));
//# sourceMappingURL=CasePhoneContactInformationType.js.map